import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import 'video.js/dist/video-js.css'
import App from './App.vue'
import VueRouter from 'vue-router'
import router from './router/index'
import store from './store/index'
import axios from 'axios'
//全局导出excel
// import htmlToExcels from './excel/htmlToExcels'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
// Vue.prototype.htmlToExcels = htmlToExcels




Vue.use(VueRouter)
Vue.config.productionTip = false
let apiRoot = VUE_APP_URL.BASE_URL//'http://127.0.0.1:5005'
Vue.prototype.$apiRoot = apiRoot
// Vue.prototype.$apiRoot = 'http://183.195.216.150:9989'
// Vue.prototype.$apiRoot = 'http://10.23.105.142:9988'

router.beforeEach((to, from, next) => {
    console.log(to.fullPath);
    if (to.fullPath == '/user/loginI') {
        console.log('11');
        // next({
        //     path: '/home'
        // })
        axios.defaults.headers = {
            "Content-Type": "application/json;charset=utf-8",
            "token": ''
        }
        axios.get(apiRoot + '/user/loginI').then(res => {
            console.log("hhhhh", res);
            if (res.data.code == 200) {
                console.log(res.data.data);
                let token = res.data.data.token
                // commit('SET_TOKEN', token)
                store.commit('SET_TOKEN')
                window.localStorage.setItem('userUuid', res.data.data.userUuid)
                // window.localStorage.setItem('password', userinfo.password)
                window.localStorage.setItem('islogin', true)
                window.localStorage.setItem('role', res.data.data.role)
                window.localStorage.setItem('token', res.data.data.token)
                axios.defaults.headers['token'] = token
                router.push('home')

            }
        })
    } else if (to.fullPath !== '/login' && to.fullPath !== '/home') {
        let token = store.getters.token || localStorage.getItem('token')
        if (token) {
            axios.defaults.headers['token'] = token
            next()
        } else {
            next('/login')
        }
    } else {
        next()
    }

})
new Vue({
    render: h => h(App),
    router,
    store
}).$mount('#app')
